const config = {
  // BASE_API: "http://192.168.1.175:9761",
  BASE_API: "http://192.168.1.13",
  REDIRECT_URI: "http://gcrz.pengdikj.com/mobile/#/login/",
  enterprise: "xxx",
  platform: "xxx",
  projectName: "development"
};

export default config;
